module.exports = __webpack_public_path__ + "media/images/lp_chishaki_interview-58e047002d5facbb1d67e47b0d693451.webp";